(function () {
  function configureModalVideos(root) {
    (root || document)
      .querySelectorAll('[data-ys-video-modal] video')
      .forEach(function (video) {
        video.setAttribute('controlslist', 'nodownload noremoteplayback');
        video.disablePictureInPicture = true;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      configureModalVideos(document);
    });
  } else {
    configureModalVideos(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    configureModalVideos(event.target);
  });
})();